export interface ImageURLSrc {
  src: URL;
}

export interface AudioURLSrc {
  src: URL;
}

export interface ImagePathAndAltText {
  path: URL;
  alt: string;
  // preloading images for reader; left and right images get different ids
  imageLeft?: HTMLImageElement;
  imageRight?: HTMLImageElement; 
}

export interface ImageCatalog {
  [name: string] : ImagePathAndAltText
}

export const FONTS = {
  imFell: 'IM Fell English',
  indieFlower: 'Indie Flower',
  montserrat: 'Montserrat',
  ebGaramond: 'Garamond',
  rockSalt: 'Rock Salt',
  reenieBeanie: 'Reenie Beanie',
  nanumBrushScript: 'Nanum Brush Script',
} as const

export type Font = typeof FONTS[keyof typeof FONTS]

export const COLORS = {
  violet: 'rgb(161, 84, 161)',
  dullViolet: 'rgb(149, 128, 149)',
  paleViolet: 'rgb(252, 243, 252)',
  indigo: 'rgb(60, 45, 122)',
  cyan: 'rgb(70, 220, 255)',
  blue: 'rgb(53, 149, 210)',
  gold: 'rgb(233, 194, 30)',
  lightYellow: 'rgb(255, 255, 224)',
  dullGreen: 'rgb(183,183,83)',
  green: 'rgb(0, 128, 0)',
  red: 'rgb(211, 50, 66)',
  white: 'rgb(255, 255, 255)',
  black: 'rgb(0, 0, 0)',
  gray: 'rgb(128, 128, 128)',
  gainsboro: 'rgb(220, 220, 220)',
  orange: 'rgb(246, 138, 53)',
  dullOrange: 'rgb(220, 166, 117)',
} as const

export type DesignColor = typeof COLORS[keyof typeof COLORS];

export interface LinearGradient {
  degrees: number;
  color1: DesignColor;
  color2: DesignColor;
}

export const SHARED_IMAGES: ImageCatalog = {
  arrowLeft: {
    path: new URL('../assets/images/arrow-left-red.png', import.meta.url),
    alt: 'hand-drawn next arrow',
  },
  arrowRight: {
    path: new URL('../assets/images/arrow-right-red.png', import.meta.url),
    alt: 'hand-drawn back arrow'
  },
  x: {
    path: new URL('../assets/images/x.png', import.meta.url),
    alt: 'hand-drawn close button',
  },
  noImage: {
    path: new URL('../assets/images/no-image.png', import.meta.url),
    alt: '',
  },
  paper: {
    path: new URL('../assets/images/paper.png', import.meta.url),
    alt: 'ball of paper',
  },
} as const;